<template>
    <div class="welfare">
        <div class="wrap">
            <img src="https://img.zhangwenpindu.cn/img/welfare-banner.png" alt="">
            <Header :isbig="true" @changeLogin="changeLogin"></Header>
            <div class="text-wrap">
                <el-divider content-position="left">短篇签约福利</el-divider>
                <div>签约对象：</div>
                <p>1、曾在知乎、UC、老福特等网站有过突出成绩的成熟作者；</p>
                <p>2、作品有外站数据的优质作者；</p>
                <p>3、萌新作者</p>
                <div>签约价格：</div>
                <p>1、保底千字20起，上不封顶，超过保底后，按50%分成。</p>
                <p>2、买断千字20起，上不封顶。</p>
                <p>3、纯分成，产生收益后直接按50%分成。</p>
                <div>签约说明：</div>
                <p>1、投稿字数要求1W——2W字。</p>
                <p>2、投稿提供历史数据，外站链接。</p>
                <p>3、禁止一稿多投，禁止搬运抄袭。</p>
                <p>4、签约成功后，次月15号左右发放稿费。</p>

            </div>
        </div>
        <Footer :big="true"></Footer>
        <Login @changeLogin="changeLogin" v-if="isshowlogin"></Login>
    </div>
</template>

<script>
    export default {};
</script>

<style lang="scss" scoped>
    .welfare {
        background: #fff;
        width: 100%;
        min-width: 1600px;

        .wrap {
            position: relative;

            img {
                display: block;
                width: 100%;
                min-height: 600px;
            }

            .header {
                background: transparent;
                position: absolute;
                top: 0;
            }

            .text-wrap {
                width: 1200px;
                height: 714px;
                background: #FFFFFF;
                border-radius: 10px;
                position: absolute;
                bottom: 146px;
                margin-left: -600px;
                left: 50%;
                padding: 20px 120px 0;
                box-sizing: border-box;

                /deep/.el-divider {
                    margin-top: 60px !important;
                }

                /deep/.is-left {
                    left: 40% !important;
                    font-size: 20px;
                    font-weight: 500;

                }

                &>div {
                    font-size: 16px;
                    color: #000;
                    line-height: 28px;
                    margin-top: 50px;
                    font-weight: 600;
                }

                &>p {
                    font-size: 16px;
                    color: #333;
                    line-height: 28px;
                }

            }
        }



    }
</style>